import { createContext, useEffect, useRef, useState } from "react";
import {
  localStorageRemove,
  localStorageSave,
} from "../../../services/localStorageService";
import PropTypes from "prop-types";
import {
  createAircraft,
  createType,
  getTypeSeries,
  removeType,
} from "../services/AircraftConfigurationService";
import { useSnackBar } from "../../../hooks/useSnackBar";
import { HTTP_RESPONSE_CODES } from "../../../globals/globals";
import { set } from "react-hook-form";

const TypeSeriesConfigurationContext = createContext();

const localStoragePrefix = "configuration/typeSeries/draft";

const localStoragePrefix2 = "configuration/aircraft/generalInfo/draft";

const TypeSeriesConfigurationProvider = ({ children }) => {
  const [typeSeriesList, setTypeSeriesList] = useState([]);
  const [newAircraft, setNewAircraft] = useState({});
  const [updateInfo, setUpdateInfo] = useState({});
  const [idxList, setIdxList] = useState({});
  const [drafts, setDrafts] = useState(getSectionsByPrefix(localStoragePrefix));
  const [filters, setFilters] = useState([]);
  
  const [idxListBackup, setIdxListBackup] = useState({});
  const [newDrafts, setNewDrafts] = useState({});
  const [loadingAircraft, setLoadingAircraft] = useState(false);
  const [maxPages, setMaxPages] = useState(null);
  const [page, setPage] = useState(0);
  const { successMsg, warningMsg, infoMsg } = useSnackBar();
  const [search, setSearch] = useState("");
  const [sortingOrder, setSortingOrder] = useState("type");
  const pageSize = 10;

  const onSearch = (value) => {
    setSearch(value);
  };
  const addAircraft = (aircraftId) => {
    infoMsg("New Aircraft", "Creating Draft", 2000);
    localStorage.setItem(localStoragePrefix2 + "/new-auto-open", "true");
    createAircraft({ id: aircraftId })
      .then((response) => {
        if (response.data.responseCode === 200) {
          let createdAircraft = response.data.load;
          setNewAircraft(createdAircraft);
        }
      })
      .catch((error) => {});
  };

  const addType = () => {
    infoMsg("New Type/Series", "Creating Draft", 2000);
    createType({ id: null })
      .then((response) => {
        if (response.data.responseCode === 201) {
          localStorage.setItem(localStoragePrefix + "/new-auto-open", "true");
          let createdPart = response.data.load;
          setIdxList((prev) => ({ ...prev, [createdPart.id]: createdPart }));
          saveDraft(createdPart.id, "general", createdPart);
          saveDraft(createdPart.id, "row", { id: createdPart.id });
          setNewDrafts((prev) => ({
            ...prev,
            [createdPart.id]: { id: createdPart.id },
          }));
          setTypeSeriesList((prev) => [createdPart, ...prev]);
        }
      })
      .catch((error) => {});
  };
  const confirmType = (aircraftId) => {
    setIdxListBackup((prev) => ({
      ...prev,
      [aircraftId]: idxList[aircraftId],
    }));
    removeDraft(aircraftId, "row");
  };
  const rowUpdater = {
    general: {
      type: (value) => ({ type: value.type_name, series: null }),
      series: (value) => ({ series: value.series_name }),
    },
  };
  const updateSection = (formValue, aircraftId, section) => {
    let { name, value } = formValue;
    updateRow(
      aircraftId,
      rowUpdater[section]?.[name]?.(value) ?? { [name]: value }
    );
  };
  const updateValue = (aircraftId, name, value) => {
    if (name === "type") {
      value = value.type_name;
      setIdxList((prev) => ({
        ...prev,
        [aircraftId]: { ...prev[aircraftId], ["series"]: null },
      }));
    }
    if (name === "series") {
      value = value.series_name;
    }
    setIdxList((prev) => ({
      ...prev,
      [aircraftId]: { ...prev[aircraftId], [name]: value },
    }));
  };

  const resetType = (aircraftId) => {
    infoMsg("Draft discarded");
    if (aircraftId in newDrafts) {
      const backup = idxListBackup[aircraftId];
      setIdxList((prev) => ({
        ...prev,
        [aircraftId]: backup,
      }));
      setTypeSeriesList((prev) =>
        prev.map((item) => (item.id === aircraftId ? backup : item))
      );
      removeDraft(aircraftId, "row");
    } else {
      removeDraft(aircraftId, "row");
    }
  };

const onFilterForceChange = (filterValue) => {
  console.log("FILTER FORCE CHANGE", filterValue);
  setFilters(prev => {
    console.log("Previous filters:", prev);
    return filterValue;
  });
};

  useEffect(() => {
  
    setLoadingAircraft(true);
    getTypeSeries(filters, page, pageSize, search, sortingOrder)
      .then((response) => {
        if (response.data.responseCode === 200) {
          setMaxPages(response.data.totalPages);

          let rowDrafts = getObjectsBySection(localStoragePrefix, "row");

          let backendItems = response.data.load.map((item) => {

            const enriched = {
              ...item,
              totalAircraft: {
                active: item.active,
                inactive: item.inactive,
                hold: item.hold,
              },
              countChilds: item.active + item.inactive + item.hold,
              isAircraft: true,
            };
            return enriched;
          });

          // Drafts que no vienen del back
          let newItems = Object.fromEntries(
            Object.entries(rowDrafts).filter(
              ([draftId]) => !backendItems.some((item) => item.id === draftId)
            )
          );
          setNewDrafts(newItems);

          // Construye idxList con prioridad a drafts
          let idxListMerged = backendItems.reduce((acc, current) => {
            const base = rowDrafts[current.id] ?? current;
            return {
              ...acc,
              [current.id]: {
                ...base,
                totalAircraft: {
                  active: base.active,
                  inactive: base.inactive,
                  hold: base.hold,
                },
                countChilds: base.active + base.inactive + base.hold,
                isAircraft: true,
              },
            };
          }, {});

          // Agrega también los drafts nuevos
          setIdxList((prev) =>
            page > 0
              ? { ...prev, ...idxListMerged }
              : { ...newItems, ...idxListMerged }
          );

          // idxListBackup solo con lo del backend
          let idxListBackupData = backendItems.reduce(
            (acc, current) => ({
              ...acc,
              [current.id]: current,
            }),
            {}
          );
          setIdxListBackup((prev) =>
            page > 0
              ? { ...prev, ...idxListBackupData }
              : { ...newItems, ...idxListBackupData }
          );

          // Lista final para mostrar: drafts si existen, sino backend
          let displayList = backendItems.map(
            (item) => rowDrafts[item.id] ?? item
          );

          // Agregamos solo drafts nuevos que no estén en displayList
          let displayIds = new Set(displayList.map((i) => i.id));
          let onlyNewDrafts = Object.values(newItems).filter(
            (item) => !displayIds.has(item.id)
          );

          setTypeSeriesList((prev) =>
            page > 0
              ? [...prev, ...onlyNewDrafts, ...displayList]
              : [...onlyNewDrafts, ...displayList]
          );
        }
        setLoadingAircraft(false);
      })
      .catch(() => setLoadingAircraft(false));
  }, [filters, page, search, sortingOrder]);

  const requestNextPage = () => {
    setPage((prev) => Math.min(prev + 1, maxPages - 1));
  };
  // Draft methods
  const saveDraft = (aircraftId, section, value) => {
    // localStorage.setItem(`${localStoragePrefix}/${section}?id=${aircraftId}`, JSON.stringify(value));
    localStorageSave(
      `${localStoragePrefix}/${section}`,
      { id: aircraftId },
      value
    );
    setDrafts((prev) => ({
      ...prev,
      [aircraftId]: (prev[aircraftId] ?? new Set()).add(section),
    }));
  };
  const isAircraftDraft = (id) => id in drafts;
  const isAircraftSectionDraft = (id, section) => drafts[id]?.has(section);
  const removeDraft = (aircraftId, section) => {
    localStorageRemove(`${localStoragePrefix}/${section}`, {
      id: aircraftId.toString(),
    });

    setDrafts((prev) => {
      // Copia el estado actual
      let prevDrafts = { ...prev };

      // Si existe el aircraftId, actualizamos sus secciones
      if (prevDrafts[aircraftId]) {
        let prevSet = new Set(prevDrafts[aircraftId]); // Clonamos el Set actual
        prevSet.delete(section); // Eliminamos la sección especificada

        if (prevSet.size > 0) {
          prevDrafts[aircraftId] = prevSet; // Actualizamos solo si quedan secciones
        } else {
          delete prevDrafts[aircraftId]; // Eliminamos el aircraftId si ya no tiene secciones
        }
      }

      return prevDrafts; // Retornamos el estado actualizado
    });
  };

  const deleteAircraft = (aircraftId) => {
    let isNewDraft = aircraftId in newDrafts;
    if (isNewDraft) {
      resetType(aircraftId);
      removeDraft(aircraftId, "general");
    }
    removeType(aircraftId)
      .then((response) => {
        if (response.data.responseCode === HTTP_RESPONSE_CODES.DELETED) {
          successMsg("Type/Series deleted successfully");
          setIdxList((prev) => {
            let copy = { ...prev };
            delete copy[aircraftId];
            return copy;
          });
          setIdxListBackup((prev) => {
            let copy = { ...prev };
            delete copy[aircraftId];
            return copy;
          });
          setTypeSeriesList((prev) =>
            prev.filter((part) => part.id !== aircraftId)
          );
        } else {
          warningMsg(
            response.data.message ||
              `Something went wrong: ${response.data.responseCode}`,
            100000
          );
        }
      })
      .catch((error) => warningMsg(`Something went wrong: ${error}`));
  };
  const updateRow = (id, partialValue) => {
    setIdxList((prev) => {
      if (isAircraftDraft(id)) {
        saveDraft(id, "row", { ...prev[id], ...partialValue });
      }
      return { ...prev, [id]: { ...prev[id], ...partialValue } };
    });
    setNewDrafts((prev) => {
      return { ...prev, [id]: { ...prev[id], ...partialValue } };
    });
  };

  return (
    <TypeSeriesConfigurationContext.Provider
      value={{
        idxList,
        updateRow,
        isAircraftDraft,
        isAircraftSectionDraft,
        saveDraft,
        removeDraft,
        deleteAircraft,
        typeSeriesList,
        requestNextPage,
        loadingAircraft,
        addType,
        updateSection,
        updateValue,
        resetType,
        confirmType,
        newDrafts,
        addAircraft,
        newAircraft,
        onSearch,
        setNewAircraft,
        setUpdateInfo,
        setSortingOrder,
        onFilterForceChange,
        setIdxList,
      }}
    >
      {children}
    </TypeSeriesConfigurationContext.Provider>
  );
};
function getSectionsByPrefix(prefix) {
  return [...Array(localStorage.length).keys()]
    .map((i) => localStorage.key(i))
    .filter((key) => key.startsWith(prefix))
    .reduce((acc, key) => {
      const queryParams = new URLSearchParams(key.split("?")[1]);
      if (localStorage.getItem("u_id") === queryParams.get("userId")) {
        let id = queryParams.get("id");
        if (!acc[id]) {
          acc[id] = new Set();
        }
        acc[id].add(key.split("?")[0].replace(prefix + "/", ""));
      }
      return acc;
    }, {});
}

function getObjectsBySection(prefix, section) {
  return [...Array(localStorage.length).keys()]
    .map((i) => localStorage.key(i))
    .filter((key) => key.startsWith(prefix + "/" + section))
    .reduce((acc, key) => {
      const queryParams = new URLSearchParams(key.split("?")[1]);
      if (localStorage.getItem("u_id") === queryParams.get("userId")) {
        const id = queryParams.get("id");
        acc[id] = JSON.parse(localStorage.getItem(key));
      }
      return acc;
    }, {});
}

export { TypeSeriesConfigurationContext, TypeSeriesConfigurationProvider };
